import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './shipmentActionTypes';
import * as actions from './shipmentActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';

function* getShipmentSaga(action) {
  try {
    const { data } = yield call(endpoints.getShipment, action.payload);
    yield put(actions.getShipmentSuccess(data));
  } catch (e) {
    yield put(actions.getShipmentError(e));
    yield put(alert.setAlertAction({
      title: 'Hata',
      text: e?.message || 'Sevkiyatlar yüklenirken hata oluştu',
      variant: 'danger',
    }));
  }
}

function* addShipmentSaga(action) {
  try {
    const { data } = yield call(endpoints.addShipment, action.payload);
    yield put(actions.addShipmentSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sevkiyat başarıyla oluşturuldu',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/shipments');
        }, 1500);
      }
    } else if (data.Result && data.Result.ErrorCode !== 0) {
      yield put(alert.setAlertAction({
        title: 'Hata',
        text: data.Result.ErrorDescription || 'Sevkiyat oluşturulurken hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.addShipmentError(e));
    yield put(alert.setAlertAction({
      title: 'Hata',
      text: e?.message || 'Sevkiyat oluşturulurken hata oluştu',
      variant: 'danger',
    }));
  }
}

function* updateShipmentSaga(action) {
  try {
    const { data } = yield call(endpoints.updateShipment, action.payload);
    yield put(actions.updateShipmentSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sevkiyat başarıyla güncellendi',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/shipments');
        }, 1000);
      }
    } else if (data.Result && data.Result.ErrorCode !== 0) {
      yield put(alert.setAlertAction({
        title: 'Hata',
        text: data.Result.ErrorDescription || 'Sevkiyat güncellenirken hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.updateShipmentError(e));
    yield put(alert.setAlertAction({
      title: 'Hata',
      text: e?.message || 'Sevkiyat güncellenirken hata oluştu',
      variant: 'danger',
    }));
  }
}

function* deleteShipmentSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteShipment, action.payload);
    yield put(actions.deleteShipmentSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sevkiyat başarıyla silindi',
        variant: 'success',
      }));
      yield put(actions.getShipmentRequest({}));
    } else if (data.Result && data.Result.ErrorCode !== 0) {
      yield put(alert.setAlertAction({
        title: 'Hata',
        text: data.Result.ErrorDescription || 'Sevkiyat silinirken hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.deleteShipmentError(e));
    yield put(alert.setAlertAction({
      title: 'Hata',
      text: e?.message || 'Sevkiyat silinirken hata oluştu',
      variant: 'danger',
    }));
  }
}

function* watchGetShipment() {
  yield takeEvery(types.GET_SHIPMENT_REQUEST, getShipmentSaga);
}
function* watchAddShipment() {
  yield takeEvery(types.ADD_SHIPMENT_REQUEST, addShipmentSaga);
}
function* watchUpdateShipment() {
  yield takeEvery(types.UPDATE_SHIPMENT_REQUEST, updateShipmentSaga);
}
function* watchDeleteShipment() {
  yield takeEvery(types.DELETE_SHIPMENT_REQUEST, deleteShipmentSaga);
}

export function* shipmentSaga() {
  yield all([
    watchGetShipment(),
    watchAddShipment(),
    watchUpdateShipment(),
    watchDeleteShipment(),
  ]);
} 